import { NsCard } from 'components/common/ns-card/NsCard';
import { NsSecondaryCta } from 'components/common/ns-secondary-cta/NsSecondaryCta';
import { HELP_CONTACT_NUMBER } from 'config/app-config';

export const testId = 'energyHelpTestId';

type EnergyHelpProps = {
  shouldShow?: boolean;
};

export const EnergyHelp = ({ shouldShow }: EnergyHelpProps) => {
  if (!shouldShow) {
    return null;
  }

  return (
    <NsCard
      testId={testId}
      decoration="engineer-long-hair"
      heading="We’re here to help"
      action={
        <NsSecondaryCta href={`tel:${HELP_CONTACT_NUMBER.GENERAL}`}>
          Call us on {HELP_CONTACT_NUMBER.GENERAL_LABEL}
        </NsSecondaryCta>
      }
    >
      <p>
        Our energy experts are ready to assist with choosing the best tariff for
        you.
      </p>
    </NsCard>
  );
};
